const SvgTimeline = props => (
  <svg width={24} height={24} viewBox='0 0 24 24' {...props}>
    <path d='M4.34 14.029l2.783-3.338a2 2 0 113.873-.562l3.117 2.078a1.992 1.992 0 011.182-.185l2.823-3.343a2 2 0 111.528 1.29l-2.785 3.297a2 2 0 11-3.857.605l-3.117-2.078a1.992 1.992 0 01-1.228.178L5.877 15.31a2 2 0 11-1.537-1.28z' />
  </svg>
);

export default SvgTimeline;
